/* v3 – force-swap by clearing srcset / data- attributes */
document.addEventListener('click', e => {
  const swatch = e.target.closest('.js-swatch');
  if (!swatch) return;

  e.preventDefault();                                   // stay on page

  const card    = swatch.closest('.product-card');
  if (!card) return;

  const mainImg = card.querySelector(
    '.product-card__image--primary, .card-product__image--primary'
  );
  const newSrc  = swatch.dataset.image;
  if (!mainImg || !newSrc) return;

  /* 1️⃣  swap photo */
  mainImg.src = newSrc;

  /* 2️⃣  clear responsive sources so browser can’t fall back to old file */
  mainImg.removeAttribute('srcset');
  mainImg.removeAttribute('sizes');
  mainImg.removeAttribute('data-src');
  mainImg.removeAttribute('data-srcset');

  /* 3️⃣  highlight active swatch */
  swatch.parentElement
        .querySelectorAll('.js-swatch--active')
        .forEach(el => el.classList.remove('js-swatch--active'));
  swatch.classList.add('js-swatch--active');
});
